import React, { useState } from "react";
import { GrClose } from "react-icons/gr";
import "./catSearch.css";
import { elakayAutoText } from "../../pageInside/dataElakay";


const CatSelected = (props) => {
    const {
        clickButton2,
        ButtonBackCategory,
        categoyseleted,
        clickBack,
        seleteCategory,
        laguangeElakay,
        infoSource,
        categories
    } = props;

    const [hoveredIndex, setHoveredIndex] = useState(null);

    const calculateFontSize = (index, totalElements) => {
        const maxSize = 18;
        const minSize = 12;
        const sizeStep = (maxSize - minSize) / (totalElements - 1);
        return maxSize - (index * sizeStep);
    };

    const selectProduct = () => (
        <form className="mb-3">
            <div className="form-group">
                <div className="boxCategory1 text-center" id="heading">
                    {/* Breadcrumb Navigation Premium */}
                    <p>
                        {Array.isArray(categories.name) && categories.name?.map((word, index) => (
                            <span
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                key={index}
                                onClick={() => clickBack(categories.categoryID[index])}
                                style={{
                                    fontSize: `${calculateFontSize(index, categories.name?.length)}px`,
                                    cursor: 'pointer'
                                }}
                                data-separator={index < categories.name?.length - 1 ? '/' : ''}
                                role="button"
                                tabIndex={0}
                                aria-label={elakayAutoText("h_f7829113ac3e3e", "Navigate to {value0} category", { value0: word })}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        clickBack(categories.categoryID[index]);
                                    }
                                }}
                            >
                                {word}
                            </span>
                        ))}
                    </p>
                </div>

                {/* Select Dropdown Premium */}
                <select
                    value={0}
                    onChange={seleteCategory()}
                    className="form-control"
                    aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryCatSelected.t001}
                >
                    <option value={0}>
                        {infoSource.laguangeElakay('label', infoSource.languageAPI).selectProdSell}
                    </option>
                    {categories.items && categories.items?.map((c, i) => (
                        <option key={i} value={c.supCategoryID._id}>
                            {infoSource.getCategoryNames(c).name[0]}
                        </option>
                    ))}
                </select>
            </div>
        </form>
    );

    return selectProduct();
};

export default CatSelected;